<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-input v-model="filter.userName" placeholder="请输入用户名" style="float: left;"></el-input>
        <el-input v-model="filter.userPhone" placeholder="请输入手机号" style="float: left;"></el-input>
        <el-select placeholder="请选择变更类型" v-model="filter.sign" style="float: left;">
          <el-option
            v-for="item in signList"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
        <el-select placeholder="请选择资产类型" v-model="filter.type" style="float: left;">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
        <el-button @click="_getList" type="primary" style="float: left;">搜索</el-button>
        <el-pagination background layout="prev, pager, next" :current-page="pageNum"
                       @current-change="pageChange"
                       :total="totalNum" v-if="paginationShow"></el-pagination>

      </div>
      <div class="categoryTable">
        <el-table ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%" border>
          <el-table-column prop="type" label="资产类型" width="160">
            <template slot-scope="scope">
              <span>{{ getType(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="用户名" />
          <el-table-column prop="userPhone" label="手机号" />
          <el-table-column prop="beforeMoney" label="修改前金额" />
          <el-table-column prop="afterMoney" label="修改后金额"/>
          <el-table-column prop="sign" label="符号" width="160">
            <template slot-scope="scope">
              <span>{{ getSign(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="本次变更金额" />
          <el-table-column prop="insertTime" label="操作时间" >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {Loading} from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getFinanceAccountChange} from 'api/request'
import {ERR_OK} from 'api/config'
import {loadingInstance, Error} from 'common/js/util'

export default {
  components: {MSidebar, MHeader},
  data () {
    return {
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      paginationShow: false,
      list: [],
      filter:{
        userName:'',
        userPhone:'',
        sign:'',
        type:'',
      },
      signList:[
        {value:"",label:'请选择'},
        {value:"1",label:'+'},
        {value:"0",label:'-'}
      ],
      typeList:[
        {value:"",label:'请选择'},
        {value:"1",label:'积分'},
        {value:"2",label:'消费券'}
      ]
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    } else {
      this._getList()
    }
  },
  methods: {
    getType (row) {
      if(row.type == 1) return "积分";
      if(row.type == 2) return "消费券";
    },
    getSign (row) {
      if(row.type == 1) return "+";
      if(row.type == 0) return "-";
    },
    // 点击分页
    pageChange (val) {
      this.pageNum = val
      this.categoryDatas = []
      this._getList()
    },
    onOption(index, row,status){
      this.showRejectModal = true
      this.editRow = row
      this.status = status
    },
    onModalOk(){
      if (!this.checkRemark) {
        this.$message('请填写备注')
        return
      }
      let param = {
        id: this.editRow.id,
        status: this.status,
        checkRemark: this.checkRemark
      }
      loadingInstance(Loading)
      postFinanceStore(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.checkRemark = null
          this.showRejectModal = false
          let text = this.status == '1'?'同意':'拒绝';
          this.$message(text)
          this._getList()
        } else {
          Error(this, res)
        }
      })
    },
    // 获取列表
    _getList () {
      let param = {
        current: this.pageNum,
        size: this.pageSize,
        userName:this.filter.userName,
        userPhone:this.filter.userPhone,
        otherName:this.filter.otherName,
        otherPhone:this.filter.otherPhone,
      }
      loadingInstance(Loading)
      getFinanceAccountChange(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.list = res.data.records
          this.totalNum = res.data.total
          if (res.data.pages > 1) {
            this.paginationShow = true
          }
        } else {
          Error(this, res)
        }
      })
    }
  }
}
</script>
<style scoped>
.userOperate{
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.userOperate .el-input {
  width:180px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.userOperate .el-button {
  width:100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}

.categoryOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}

.categoryTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}

.categoryOperate .el-input {
  width: 180px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}

.categoryOperate .el-button {
  width: 100px;
  height: 40px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/finance/accountChange.vue